// export const searchAppChoicesReducer = () => {
//   return [
//     {
//       label: 'Studio BFF',
//       value: 'Studio%20BFF',
//     },
//     {
//       label: 'BFF',
//       value: 'bff',
//     },
//     {
//       label: 'ApptioConnect API',
//       value: 'apptioconnect%20api',
//     },
//     {
//       label: 'ApptioConnect UI',
//       value: 'apptioconnect%20ui',
//     },
//     {
//       label: 'ApexShell - Engineering',
//       value: 'ApexShell%20-%20Engineering',
//     },
//     {
//       label: 'ULS',
//       value: 'uls',
//     }
//   ]
// }

import { APPLICATIONS } from "../constant/constant";

export default function searchAppReducer (state= APPLICATIONS.STUDIOBFF, action: { type: string, payload: string }) {
  switch (action.type) {
    case "SEARCH_APP":
      return action.payload;
    default:
      return state;
  }
}

export const applicationPrimaryVersion= (state= APPLICATIONS.STUDIOBFF, action: { type: string, payload: string }) => {
  switch (action.type) {
    case "APP_VERSION":
      return action.payload;
    default:
      return state;
  }
}

export  function getApplicationName(state= "BFF", action: { type: string, payload: string }) {
  switch (action.type) {
    case "ITP":
      return action.payload;
    default:
      return state;
  }
}

export  function getAdminTabName(state= "", action: { type: string, payload: string }) {
  switch (action.type) {
    case "CHANGE_TAB_ADMIN":
      return action.payload;
    default:
      return state;
  }
}